export enum WorkspacePrefix {
  Markets = 'MARKET',
  ResearchBoard = 'RB'
}
